const LEFT_PAGES = 2;
const VISIBLE_SHOULDER_PAGES = 5;

export const isExternalPage = (pageNumber: number, currentPage: number, maxPage: number): boolean => {
  const isFirst = pageNumber <= LEFT_PAGES;
  const isLast = pageNumber === maxPage;
  const isVisible = isFirst || isLast;
  const isExternal = Math.abs(currentPage - pageNumber) === VISIBLE_SHOULDER_PAGES;

  return !isVisible && isExternal;
};
